<img [src]="src" [alt]="alt" [ngClass]="class" />
